export default __webpack_public_path__ + "static/Group 524-2bfafb5905d2f2be04646097de679962.png";